export const INPUT_TYPE_HIDDEN = 'hidden';
export const INPUT_TYPE_AUTOCOMPLETE = 'autocomplete';
export const INPUT_TYPE_SELECT_CHOSEN = 'selectChosen';
export const INPUT_TYPE_DATE = 'date';
export const INPUT_TYPE_CITY = 'city';
export const INPUT_TYPE_STRING = 'string';
export const INPUT_TYPE_NAME = 'name';
export const INPUT_TYPE_EMAIL = 'email';
export const INPUT_TYPE_CURRENCY = 'currency';
export const INPUT_TYPE_PHONE = 'phone';
export const INPUT_TYPE_STATE = 'state';
export const INPUT_TYPE_URL = 'uRL';
export const INPUT_TYPE_COUNTRY = 'country';
export const INPUT_TYPE_EMAIL_STATUS = 'emailStatus';
export const INPUT_TYPE_SELECT_LANGUAGE_CODE = 'selectLanguageCode';
export const INPUT_TYPE_LEADSOURCE = 'leadsource';
export const INPUT_TYPE_CONTACT_TYPE = 'contactType';
export const INPUT_TYPE_CONTACT_TITLE = 'contactTitle';
export const INPUT_TYPE_USERS = 'users';
export const INPUT_DAY_OF_WEEK = 'dayOfWeek';
export const INPUT_SELECT_WITH_DEFAULT = 'selectWithDefault';
export const INPUT_DOUBLE = 'double';
export const INPUT_INTEGER = 'integer';
export const INPUT_PERCENT = 'percent';
export const INPUT_DRILL_DOWN = 'drilldown';
export const INPUT_SELECT_RADIO = 'selectRadio';
export const INPUT_YES_NO_RADIO = 'yesNoRadio';
export const INPUT_MONTH = 'month';
export const INPUT_CUSTOM_EMAIL = 'customEmail';
export const INPUT_YEAR = 'year';
export const INPUT_STATE_SELECT = 'stateSelect';
export const INPUT_TEXT_AREA = 'textArea';
export const INPUT_DATETIME = 'dateTime';
export const INPUT_MULTISELECT = 'multiSelect';
export const INPUT_BOOLEAN = 'boolean';

export const TAGS_FIELD_KEY = 'tags_Field';

export const convertFromStringToDp = (dateString) => {
    if (typeof dateString !== 'string' || dateString.trim() === '') {
        // eslint-disable-next-line no-console
        console.error('Invalid input: dateString must be a non-empty string.');

        return '';
    }

    const [month, day, year] = dateString.split('-');

    return `${year}-${month}-${day}`;
};

export const convertFromDpToString = (dateString) => {
    if (typeof dateString !== 'string' || dateString.trim() === '') {
        // eslint-disable-next-line no-console
        console.error('Invalid input: dateString must be a non-empty string.');

        return '';
    }

    const [year, month, day] = dateString.split('-');

    return `${month}-${day}-${year}`;
};

export const getTagsList = (itemsObj) => {
    return Object.entries(itemsObj || {})
        .filter(([, raw]) => typeof raw === 'string' && raw !== '')
        .map(([id, raw]) => {
            const parts = raw.split('->').map((x) => x.trim());

            const uncategorized = parts.length !== 2 || !parts[0] || !parts[1];
            const categoryName = uncategorized ? '' : parts[0];
            const tagLabel = uncategorized ? raw : parts[1];

            return {
                label: raw,
                categoryLabel: categoryName,
                tagLabel,
                value: id,
            };
        })
        .sort((a, b) => {
            const aIsUncategorized = a.categoryLabel === '';
            const bIsUncategorized = b.categoryLabel === '';

            if (aIsUncategorized && !bIsUncategorized) {
                return -1;
            }

            if (!aIsUncategorized && bIsUncategorized) {
                return 1;
            }

            const categoryCompare = a.categoryLabel.localeCompare(b.categoryLabel);

            if (categoryCompare !== 0) {
                return categoryCompare;
            }

            return a.tagLabel.localeCompare(b.tagLabel);
        });
};
